import { Link } from "react-router-dom";
import { CheckCircle2, ArrowRight, ShieldCheck } from "lucide-react";
import { useLang } from "../../i18n";
import { resolveMedia } from "../../lib/api";
import { MALARIA_TIPS } from "../../data/content";
import { Reveal, SectionHeading } from "../Reveal";

const MALARIA_POSTER = "/api/files/anansha-welfare/uploads/bd19be71-2188-4162-a9da-a6d4a60029f7.jpeg";

export default function Malaria() {
  const { pick, lang } = useLang();
  const tips = MALARIA_TIPS[lang] || MALARIA_TIPS.hi;
  return (
    <section data-testid="malaria-section" className="py-24 bg-ngo-forest relative overflow-hidden">
      <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-ngo-deep/50 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-14 items-center relative">
        <div>
          <SectionHeading
            dark
            overline={pick({ hi: "विशेष अभियान", en: "Featured Campaign" })}
            title={pick({ hi: "मलेरिया से बचाव – जागरूकता ही सुरक्षा है", en: "Malaria Prevention – Awareness is Protection" })}
            description={pick({
              hi: "अंशा वेलफेयर सोसाइटी द्वारा समुदाय में मलेरिया से बचाव, स्वच्छता और मच्छरों से होने वाले संक्रमण के प्रति जागरूकता बढ़ाने के लिए अभियान चलाया गया।",
              en: "Anansha Welfare Society ran a campaign to raise community awareness about malaria prevention, hygiene and mosquito-borne infections.",
            })}
            testid="malaria-heading"
          />
          <ul className="mt-8 space-y-3.5">
            {tips.map((tip, i) => (
              <Reveal key={i} i={i}>
                <li className="flex items-start gap-3 text-ngo-mint/90 text-sm sm:text-base">
                  <CheckCircle2 size={19} className="shrink-0 mt-0.5 text-ngo-gold" />
                  {tip}
                </li>
              </Reveal>
            ))}
          </ul>
          <Reveal i={5}>
            <Link
              to="/campaigns"
              data-testid="malaria-gallery-btn"
              className="group mt-9 inline-flex items-center gap-2.5 px-7 py-3.5 rounded-full bg-ngo-gold text-ngo-ink font-semibold hover:-translate-y-1 hover:shadow-[0_14px_36px_rgba(216,169,40,0.4)] transition-[transform,box-shadow] duration-300"
            >
              {pick({ hi: "अभियान की तस्वीरें देखें", en: "View Campaign Photos" })}
              <ArrowRight size={17} className="group-hover:translate-x-1 transition-transform duration-300" />
            </Link>
          </Reveal>
        </div>
        <Reveal i={2} className="relative">
          <div className="relative rounded-[2rem] overflow-hidden shadow-[0_30px_80px_rgba(0,0,0,0.4)]">
            <img
              src={resolveMedia(MALARIA_POSTER)}
              alt="मलेरिया जागरूकता अभियान — आधिकारिक पोस्टर"
              className="w-full aspect-[4/3] object-cover hover:scale-105 transition-transform duration-700"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ngo-forest/70 to-transparent" />
            <div className="absolute bottom-5 left-5 flex items-center gap-2.5 bg-ngo-cream/95 rounded-full px-5 py-2.5">
              <ShieldCheck size={18} className="text-ngo-deep" />
              <span className="text-sm font-semibold text-ngo-forest">{pick({ hi: "मलेरिया जागरूकता अभियान", en: "Malaria Awareness Campaign" })}</span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
